var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngularMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.2 192.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffa726;}.cls-2{fill:#fb8c00;}.cls-3{fill:#ffe0b2;}.cls-4{fill:#fff3e0;}.cls-5{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "material") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.4 0 89.4 0 89.4 0 0 32 13.5 150.4 89.4 192.7 89.4 192.7 89.4 192.7 165.4 150.4 179.2 32 89.4 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.4 0 89.4 21.4 89.4 21.4 89.4 118.7 89.4 118.7 89.4 192.7 89.4 192.7 165.4 150.4 179.2 32 89.4 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "102.9 146.3 39.6 115.8 75.9 93.4 139.6 124 102.9 146.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "102.9 122.8 39.6 92.2 75.9 69.9 139.6 100.5 102.9 122.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "102.9 99.3 39.6 68.7 75.9 46.3 139.6 76.9 102.9 99.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularMaterial);
export default __webpack_public_path__ + "static/media/angular-material.3c3fa50e6e1dbcfc0510fa11a131d016.svg";
export { ForwardRef as ReactComponent };